const minHeight = typeof window !== "undefined" && window.innerHeight;
const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: "100vh",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  textField: {
    display: "block",
    marginBottom: 30,
    maxWidth: 570
  },
  block: {
    display: "block"
  },
  modal: {
    minHeight: 200,
    minWidth: 600,
    maxHeight: 600,
    maxWidth: minWidth / 1.5,
    marginTop: theme.spacing.unit * 3,
    overflow: "auto",
    width: 600
  },
  modalHeader: {
    fontWeight: "600!important",
    fontSize: "1.2rem!important",
    textTransform: "none!important"
  },
  form: {
    height: 430,
    overflowY: "scroll"
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    minWidth: 40
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    alignItems: "right",
    '&:hover': {
      backgroundColor: "#fd5622"
    }
  },
  close: {
    padding: 0,
    minWidth: 40
  },
  flex: {
    flex: 1
  },
  summary: {
    padding: theme.spacing.unit
  },
  noDataBox: {
    margin: 20
  },
  rootModal: {
    maxHeight: 600
  },
  modalFooter: {
    display: "flex",
    justifyContent: "space-between"
  }
});

export default styles;
